// typings
import { ServerIntervals } from 'modules/TradingChart/consts';
import { TimeIntervals } from '../../../typings';

export const DEFAULT_CHART_INTERVAL_TV = '5'; // 5m

export const CHART_TO_USER_INTERVAL: {
  [key in TimeIntervals]: TradingChartUserPeriod;
} = {
  1: '1m',
  3: '3m',
  5: '5m',
  10: '10m',
  15: '15m',
  30: '30m',
  60: '1h',
  120: '2h',
  180: '3h',
  240: '4h',
  '1D': 'D',
  '1W': 'W',
  '1M': 'M',
};

const USER_TO_CHART_INTERVAL: {
  [key in TradingChartUserPeriod]: TimeIntervals;
} = {
  '1m': '1',
  '3m': '3',
  '5m': '5',
  '10m': '10',
  '15m': '15',
  '30m': '30',
  '1h': '60',
  '2h': '120',
  '3h': '180',
  '4h': '240',
  D: '1D',
  W: '1W',
  M: '1M',
};

class TVFormatService {
  getUserPeriodByChartInterval(
    chartInterval: TimeIntervals,
  ): TradingChartUserPeriod {
    let mappedUserPeriod = CHART_TO_USER_INTERVAL[chartInterval];

    // Mapping for custom interval
    if (!mappedUserPeriod) {
      let intervalValue = Number(chartInterval);

      // If custom interval is in minutes or hours
      if (!Number.isNaN(intervalValue)) {
        const isHour = intervalValue % 60 === 0;
        intervalValue = isHour ? intervalValue / 60 : intervalValue;
        const intervalUnits = isHour ? 'h' : 'm';
        mappedUserPeriod = `${intervalValue}${intervalUnits}` as TradingChartUserPeriod;
      } else {
        // If custom interval is in days, weeks or months
        mappedUserPeriod = chartInterval as TradingChartUserPeriod;
      }
    }

    return mappedUserPeriod;
  }

  getChartIntervalByUserPeriod(
    userInterval: TradingChartUserPeriod,
  ): TimeIntervals {
    let mappedInterval = USER_TO_CHART_INTERVAL[userInterval];

    // Mapping for custom interval
    if (!mappedInterval) {
      const units = userInterval.slice(-1);
      switch (units) {
        case 'h':
        case 'm': {
          // if interval is in hours or minutes
          const intervalValue = Number(userInterval.slice(0, -1));
          const mappedValue = units === 'h' ? `${intervalValue * 60}` : `${intervalValue}`;
          mappedInterval = mappedValue as TimeIntervals;
          break;
        }
        default:
          // if interval is in days, weeks or months
          mappedInterval = userInterval as TimeIntervals;
          break;
      }
    }

    return mappedInterval;
  }

  mapTVChartInterval= (interval: string) => {
    let intervalOHLC: ServerIntervals = ServerIntervals.ONE_MINUTE;

    switch (interval?.slice(-1)) {
      case 'D':
      case 'M':
      case 'W':
        intervalOHLC = ServerIntervals.ONE_DAY;
        break;
      default:
        intervalOHLC = ServerIntervals.ONE_MINUTE;
        break;
    }

   return intervalOHLC;
  };
}

export default new TVFormatService();
